// extracted by css-extract-rspack-plugin
export default {"wrapper":"MediaGalleryItem_wrapper__jkxh8"};